import React, { Component } from 'react';
import gql from 'graphql-tag';
import withStyles from '@mui/styles/withStyles';
import { InputAdornment } from '@mui/material';
import ColumnLayout from '../../components/layout/ColumnLayout';
import Grid from '../../components/layout/Grid';
import Paper from '../../components/layout/Paper';
import Inline, { inlineAlignment } from '../../components/layout/Inline';
import ViewHeader from '../../components/header/ViewHeader';
import Separator from '../../components/layout/Separator';
import Product from '../../fragments/Product';
import { niceDateFromString, shortDateTimeFromString } from '../../utils/date';
import TextField from '../../components/form/TextField';
import Label from '../../components/form/Label';
import { getClient } from '../../utils/apollo';
import HtmlEditor from '../../components/form/HtmlEditor';
import { GST } from '../../utils/bookable';
import Checkbox from '../../components/form/Checkbox';
import Select from '../../components/form/Select';
import { getOffice, getSiteConfig } from '../../environment';
import ImageDetailsCard from '../../components/cards/ImageDetailsCard';
import UploadField from '../../components/form/UploadField';
import AutoComplete from '../../components/form/AutoComplete';
import TagButton from '../../components/form/TagButton';
import { validationHelper } from '../../utils/validation';
import { isNullOrUndefined } from '../../utils/objects';
import ValidationPlaceholder from '../../components/form/ValidationPlaceholder';
import AlertBar from '../../components/form/AlertBar';

class StockItemView extends Component {
    state = {
        productCategories: []
    };

    componentDidMount() {
        this._isMounted = true;
        const loadCategories = async () => {
            const query = gql`
                query ReadProductCategories {
                    readProductCategories(
                        filter: { ClassName: { in: [_CremationManagerProductCategory] } }
                    ) {
                        nodes {
                            ID
                            Title
                            URLSegment
                        }
                    }
                }
            `;
            const { data } = (await getClient().query({ query })) || {};
            return data;
        };
        loadCategories().then(data => {
            if (data && data.readProductCategories) {
                if (this._isMounted) {
                    this.setState({
                        productCategories: data.readProductCategories.nodes.map(({ __typename, ...parts }) => parts)
                    });
                }
            }
        });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const { classes, form } = this.props;
        const { XeroAccountsCM } = getSiteConfig();
        let allAccounts = { costs: [], sales: [] };
        try {
            allAccounts = JSON.parse(XeroAccountsCM) || {};
        } catch (e) {
            // dude, where's my accounts?
        }
        const costs = Object.keys(allAccounts.costs).map(key => ({ label: allAccounts.costs[key], value: key }));
        const sales = Object.keys(allAccounts.sales).map(key => ({ label: allAccounts.sales[key], value: key }));
        return (
            <Grid container>
                <Grid item>{this.renderHeader()}</Grid>
                <Grid item>
                    <Paper elevation={0}>
                        <Grid container>
                            <Grid item>{this.renderStockDetails()}</Grid>

                            <Grid item>
                                <Separator />
                            </Grid>

                            <ColumnLayout>
                                {this.renderCostsColumn(costs)}
                                {this.renderSalesColumn(sales)}
                            </ColumnLayout>

                            <Grid item>
                                <Separator />
                            </Grid>

                            {this.renderItemDetails()}
                            {this.renderItemPhotos()}
                            <Grid item>
                                <Separator />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                {this.renderStockActive()}
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <p className={classes.metadata}>
                                    <strong>Date Created: </strong>
                                    <span className="regular">{niceDateFromString(form.getField('Created'))}</span>
                                    <br />
                                    <strong>Last Updated: </strong>
                                    <span
                                        className="regular">{shortDateTimeFromString(form.getField('LastEdited'))}</span>
                                </p>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        );
    }

    renderHeader() {
        const { itemId, form } = this.props;
        let subtitle = 'New Item';
        if (itemId > 0) {
            subtitle = <><strong>{form.getField('InternalItemID')}</strong> {form.getField('Title')}</>;
        }
        return (
            <ViewHeader title="Catalogue Item" subtitle={subtitle} />
        );
    }


    renderStockDetails() {
        const { validationBadges } = this.props;
        return (
            <Inline className="enquiry-header" alignment={inlineAlignment.rightAlignSiblings} center>
                <div style={{ display: 'flex', margin: '1rem 1rem 0' }}>
                    <div className="sort-by-container" style={{ width: 'unset' }}>
                        <div style={{ lineHeight: 1.5 }}>
                            <Label className="label brand">Overview & Pricing</Label>
                        </div>
                    </div>
                    {<div className="tabs">{!!validationBadges && validationBadges()}</div>}
                </div>
            </Inline>
        );
    }

    renderStockActive() {
        const { form } = this.props;
        const isActive = form.getField('AllowPurchase');
        return (
            <Grid bucket>
                <Grid item xs={12}>
                    <Checkbox form={form} name="AllowPurchase" label="Active (not retired)" />

                    {!isActive && (
                        <AlertBar variant="error">
                            Retired items do not appear in searches and cannot be added to new quotes, bills or
                            invoices.
                        </AlertBar>
                    )}
                </Grid>
            </Grid>
        );
    }

    renderSalesColumn(sales) {
        const { form } = this.props;
        const salesCode = form.getField('XeroSalesCode');
        if (sales.length && !isNullOrUndefined(salesCode)) {
            if (!sales.find(obj => salesCode === obj.value)) {
                sales.unshift({ label: `[${salesCode}] UNKNOWN`, value: salesCode });
            }
        }
        const wholesalePrice = form.getField('PriceOverrides[0].SellingPrice');
        const setWholesalePrice = (evt, val) => {
            const newPrice = [];
            const { ID } = getOffice();
            if (val > 0 || val < 0) {
                const useGST = form.getField('GST');
                const BasePrice = useGST ? val - (val / ((GST + 1) * 10)) : Number(val);
                newPrice[0] = { SellingPrice: '' + val, PriceTier: 1, BasePrice, ID };
            }
            form.setField({ 'PriceOverrides': newPrice });
        };
        const useGST = form.getField('GST');
        return (
            <Grid container>
                <Grid item>
                    <Grid bucket>
                        <Grid item xs={12}>
                            <h4>Sales (Invoices & Quotes)</h4>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                onChange={() => this.updateBase('BasePrice')}
                                form={form} name="SellingPrice" type="number"
                                label={'Retail Price' + (useGST ? ' (inc.GST)' : ' (GST-Free)')}
                                InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            {sales && sales.length ? (
                                <Select
                                    form={form} name="XeroSalesCode" label="Sales Account"
                                    options={sales}
                                />
                            ) : (
                                <TextField form={form} name="XeroSalesCode" label="Sales Account" />
                            )}
                        </Grid>
                        <Grid item xs={12}>
                            <Checkbox form={form} name="GST" label="Item sale is subject to GST"
                                      onChange={() => this.updateBase('BasePrice')} />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                value={wholesalePrice} onChange={setWholesalePrice} type="number"
                                label={'Wholesale Price' + (useGST ? ' (inc.GST)' : ' (GST-Free)')}
                                InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    renderCostsColumn(costs) {
        const { form } = this.props;
        const costsCode = form.getField('XeroCostsCode');
        if (costs.length && !isNullOrUndefined(costsCode)) {
            if (!costs.find(obj => costsCode === obj.value)) {
                costs.unshift({ label: `[${costsCode}] UNKNOWN`, value: costsCode });
            }
        }
        const useGST = form.getField('ITC');
        return (
            <Grid container>
                <Grid item>
                    <Grid bucket>
                        <Grid item xs={12}>
                            <h4>Purchase (Bills)</h4>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                onChange={() => this.updateBase('BaseWorth')}
                                form={form} name="PurchasePrice" type="number"
                                label={'Purchase Cost' + (useGST ? ' (inc.GST)' : ' (GST-Free)')}
                                InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            {costs && costs.length ? (
                                <Select
                                    form={form} name="XeroCostsCode" label="Purchases Account"
                                    options={costs}
                                />
                            ) : (
                                <TextField form={form} name="XeroCostsCode" label="Purchases Account" />
                            )}
                        </Grid>
                        <Grid item xs={12}>
                            <Checkbox form={form} name="ITC" label="Item purchase is subject to GST"
                                      onChange={() => this.updateBase('BaseWorth')} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    renderItemDetails() {
        const { form } = this.props;
        return (
            <Grid item xs={12} md={7}>
                <Grid bucket>
                    <Grid item><h4>Item Details</h4></Grid>
                    <Grid item>
                        <TextField form={form} name="Title" label="Title" required />
                    </Grid>
                    <Grid item>
                        <TextField form={form} name="InternalItemID" label="Item Code/SKU" required />
                    </Grid>
                    <Grid item>
                        <HtmlEditor form={form} name="Content" label="Description" height={300} />
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    renderItemCategories() {
        const { form } = this.props;
        const parentID = form.getField('Parent.ID');
        const extraCategories = form.getField('ProductCategories') || [];
        const { productCategories } = this.state;
        const categoryOptions = productCategories
            .map(obj => ({
                label: obj.Title,
                value: obj.ID
            }))
            .sort((a, b) => (a.label < b.label ? -1 : 1));
        const extrasOptions = categoryOptions.filter(obj => {
            if (parentID === obj.value) return false;
            if (!extraCategories.length) return true;
            return !extraCategories.find(cat => {
                return obj.value === cat.ID;
            });
        });
        const onChangeMain = (evt, val) => {
            const wasID = form.getField('Parent.ID');
            if (val > 0 && val !== wasID) {
                const { productCategories } = this.state;
                const Parent = productCategories.find(obj => val === obj.ID);
                if (Parent) {
                    form.setField({ Parent });
                }
            }
        };
        const onChangeExtra = item => {
            if (item && item.value && item.value > 0) {
                const ProductCategories = extraCategories.toSpliced();
                const { productCategories } = this.state;
                const newItem = productCategories.find(obj => obj.ID === item.value);
                if (newItem) {
                    ProductCategories.push(newItem);
                    form.setField({ ProductCategories });
                }
            }
        };
        const onClickRemove = ID => {
            if (ID && ID > 0) {
                const ProductCategories = extraCategories.filter(obj => ID !== obj.ID);
                form.setField({ ProductCategories });
            }
        };
        return (
            <Grid bucket>
                <Grid item xs={12}>
                    <h4>Item Categorisation</h4>
                </Grid>
                <Grid item xs={12}>
                    <ValidationPlaceholder form={form} name="Parent.ID">
                        <Select
                            required
                            label="Core Category"
                            allowNone={false}
                            options={categoryOptions}
                            value={parentID}
                            onChange={onChangeMain}
                        />
                    </ValidationPlaceholder>
                </Grid>
                <Grid item xs={12}>
                    <AutoComplete
                        placeholder={
                            extraCategories && !!extraCategories.length
                                ? 'Add another category...'
                                : 'Add an extra category...'
                        }
                        label="Additional Categories"
                        options={extrasOptions}
                        clearOnSelect
                        onChange={onChangeExtra}
                    />
                    {!!extraCategories && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                            {extraCategories.map(obj => (
                                <TagButton key={obj.ID} text={obj.Title} onClickRemove={() => onClickRemove(obj.ID)} />
                            ))}
                        </div>
                    )}
                </Grid>
            </Grid>
        );
    }

    renderItemPhotos() {
        const { form } = this.props;
        const ImageID = form.getField('ImageID');
        const ImageURL = form.getField('ImageURL');

        const handleUploadAttachment = (uploadFile) => {
            form.setField({
                ImageID: uploadFile.ID,
                ImageURL: uploadFile.AbsoluteLink
            });
        };

        const onAttachmentRemove = () => {
            form.setField({ ImageID: null, ImageURL: null });
        };

        return (
            <Grid item xs={12} md={5}>
                {this.renderItemCategories()}
                <Grid bucket>
                    <Grid item>
                        <h4>Product Photo</h4>
                    </Grid>
                    <Grid item>
                        {ImageURL && ImageID > 0 && (
                            <ImageDetailsCard
                                photo={{ File: { AbsoluteLink: ImageURL } }}
                                onClickRemoveAction={() => onAttachmentRemove()}
                                onClickOpenImage={() => window.open(ImageURL)}
                            />
                        )}
                        <UploadField
                            folderPath="/productimages"
                            accept=".png, .jpg, .jpeg, .gif"
                            prompt="Upload Photo"
                            publish
                            onComplete={({ uploadFile }) => handleUploadAttachment(uploadFile)}
                        />
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    updateBase = (baseField) => {
        const { form } = this.props;
        let sourceField = 'SellingPrice';
        let useGST = form.getField('GST');
        if ('BaseWorth' === baseField) {
            sourceField = 'PurchasePrice';
            useGST = form.getField('ITC');
        }
        const sourceValue = Number(form.getField(sourceField));
        let baseValue = !!useGST && sourceValue > 0 ? sourceValue - (sourceValue / ((GST + 1) * 10)) : Number(sourceValue);
        form.setField({ [baseField]: baseValue, [sourceField]: '' + sourceValue });
    };
}

const styles = ({ breakpoints }) => ({
    metadata: {
        textAlign: 'end',
        [breakpoints.down('sm')]: {
            textAlign: 'start'
        }
    }
});

const reduceOverridesOnLoad = data => {
    return data.PriceOverrides.edges.map(({ node }) => ({
        ID: node.ID, // OfficeID
        BasePrice: node._join.PriceOverride.BasePrice,
        PriceTier: node._join.PriceOverride.PriceTier,
        SellingPrice: node._join.PriceOverride.SellingPrice
    }));
};
const reduceOverridesOnSave = data => {
    return data.PriceOverrides.map(({ SellingPrice, ...obj }) => obj).filter(obj => !!obj.ID); // drop when no office selected
};

export default {
    id: 'Stock',
    label: 'Overview',
    component: withStyles(styles)(StockItemView),
    fragment: Product,
    onLoad: data => {
        if (data.PriceOverrides) {
            data.PriceOverrides = reduceOverridesOnLoad(data);
        }
    },
    formatSaveData: (saveData, state) => {
        saveData.PurchasePrice = '';
        saveData.SellingPrice = '';
        if (saveData.PriceOverrides) {
            saveData.PriceOverrides = reduceOverridesOnSave(state);
        }

        if (saveData.ProductCategories) {
            saveData.ProductCategories = state.ProductCategories.map(obj => ({ ID: obj.ID }));
        }

        if (saveData.Parent && saveData.Parent.ID > 0) {
            saveData.ParentID = saveData.Parent.ID;
            delete saveData.Parent;
        }

        delete saveData.Image;
        saveData.ImageURL = '';
    },
    validation: {
        required: ['InternalItemID', 'Title', 'Parent.ID'],
        suggested: ['Content'],
        onValidate: {
            XeroCostsCode: (newValue, oldValue, isSet, getField) => {
                const hasValue = (!!newValue || (!!oldValue && isNullOrUndefined(newValue)));
                if (hasValue) return validationHelper.ok();
                if (getField('PurchasePrice') > 0) {
                    return validationHelper.suggested();
                }
                return validationHelper.ok();
            },
            XeroSalesCode: (newValue, oldValue, isSet, getField) => {
                const hasValue = (!!newValue || (!!oldValue && isNullOrUndefined(newValue)));
                if (hasValue) return validationHelper.ok();
                if (getField('SellingPrice') > 0) {
                    return validationHelper.required();
                }
                return validationHelper.ok();
            }
        }
    }
};
